module.exports = __webpack_public_path__ + "img/xfg.d5ebfec0.jpg";